import { UserInterface } from '@e3labs/isa-data-dictionary';
import { AxiosResponse } from 'axios';
import api from '~/services/api';

class ControlNotificationsService {
  getAll({ ...rest }: any): Promise<AxiosResponse> {
    return api.get('/intelligence/notifications/not-read', {
      params: {
        ...rest
      }
    });
  }

  getCount({ ...rest }: any): Promise<AxiosResponse> {
    return api.get('/intelligence/notifications/not-read/count?', {
      params: {
        ...rest
      }
    });
  }

  getCSV({ ...params }: any): Promise<AxiosResponse> {
    return api.get('/intelligence/notifications/not-read?generateCSV=true', {
      params: {
        ...params
      }
    });
  }

  getSellers({ ...rest }): Promise<AxiosResponse<UserInterface[] | null>> {
    return api.get('/user', {
      params: {
        ...rest
      }
    });
  }
}

export default new ControlNotificationsService();
